module.exports = __webpack_public_path__ + "img/vip-coupon.8f60bd7b.png";